module.exports = {"name":"Tabuľka","icon":"<i class='material-icons'>border_all</i>","widget":{"type":"html-table","initData":{"html":"<table><tbody><tr><td></td><td></td></tr><tr><td></td><td></td></tr></tbody></table>"}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/html-table/html-table.json
// module id = 336
// module chunks = 0